document.addEventListener('DOMContentLoaded', function() {
  const swiperContainer = document.querySelector('.swiper-benefits');
  if (!swiperContainer) return;
  
  const activeSlide = parseInt(swiperContainer.dataset.activeSlide) || 0;
  
  new Swiper('.swiper-benefits', {
    slidesPerView: 1.8,
    spaceBetween: 5,
    initialSlide: activeSlide,
    mousewheel: { forceToAxis: true },
    breakpoints: {
      768: {
        slidesPerView: 5,
        spaceBetween: 5
      }
    }
  });
});
